<template>
  <div>
 <div v-if="isPermission">
  <CCard class="shadow-sm" >
   <CCardBody>
    <div class="row">
     <div class="col-md-12 col-12 col-sm-12 d-inline-flex align-items-center">
      <!-- <h2 class="card-title mb-1 font-weight-normal">
             {{ $t('exportReportsByEmail') || 'ส่งออกรายงานทางอีเมล' }}
            </h2> -->
      <h2 class="card-title mb-1 font-weight-normal">
       {{ $t("exportReports") || "ร้องขอรายงานจากระบบ" }}
      </h2>
     </div>
    </div>
    <!-- <p class="text-muted mb-3">
          {{ $t('exportAllBranchesDesc') ||'หน้านี้จะส่งออกข้อมูลรวมทุกสาขาโดยอัตโนมัติ ไม่ต้องเลือกสาขา ระบบจะส่งไฟล์ไปยังอีเมลร้าน และสามารถเพิ่มอีเมลสำเนา (CC) ได้' }}
        </p> -->
    <p class="text-muted mb-1">
     {{
      $t("exportAllBranchesDesc") ||
      'เลือกประเภทรายงานและช่วงวันที่ที่ต้องการ แล้วกด "ร้องขอเอกสาร" จากนั้นสามารถดาวน์โหลดไฟล์ได้จากประวัติด้านล่างเมื่อสถานะเป็น "ดาวน์โหลด"'
     }}
    </p>
    <small class="d-block mb-3 text-primary">
      <i class="fi fi-rr-exclamation mr-1"></i>
      {{
        $t("exportLimitHint")
      }}
      <br />
      <i class="fi fi-rr-clock mr-1"></i>
      {{
        $t("exportGenerateTimeHint")
      }}
    </small>
    <!-- ✅ กล่องอธิบายวิธีใช้งาน -->
    <!-- <div class="usage-steps mb-3">
          <div class="usage-title">
            {{ $t('exportUsageTitle') || 'วิธีใช้งานการร้องขอรายงาน' }}
          </div>
          <ol class="usage-list mb-2">
            <li>
              {{ $t('exportUsageStep1') || 'เลือกประเภทรายงานที่ต้องการ (เลือกได้มากกว่า 1 รายการ)' }}
            </li>
            <li>
              {{ $t('exportUsageStep2') || 'เลือกช่วงวันที่ของข้อมูลที่ต้องการออกรายงาน (ไม่เกิน 31 วัน)' }}
            </li>
            <li>
              {{ $t('exportUsageStep3') || 'กดปุ่ม "ร้องขอเอกสาร" และยืนยันในหน้าต่างยืนยันการร้องขอ' }}
            </li>
            <li>
              {{
                $t('exportUsageStep4') ||
                'ติดตามสถานะได้จากตารางประวัติด้านล่าง เมื่อสถานะเป็น "ดาวน์โหลด" ให้กดปุ่มเพื่อดาวน์โหลดไฟล์'
              }}
            </li>
          </ol>
          <small class="text-muted d-block">
            {{
              $t('exportNotifyByEmailHint') ||
              'เมื่อรายงานพร้อมให้ดาวน์โหลด ระบบจะแจ้งเตือนไปยังอีเมลเจ้าของร้านโดยอัตโนมัติ'
            }}
          </small>
        </div> -->

    <CAlert
    v-if="submitMsg || (submitItems && submitItems.length > 0)"
     :color="alertColor"
     :show.sync="showSubmitAlert"
     class="mt-2 submit-alert">
     <!-- Header -->
     <div class="submit-alert__header">
      <div class="submit-alert__icon-wrapper">
       <i :class="alertIconClass"></i>
      </div>
      <div class="submit-alert__header-text">
       <div class="submit-alert__title">
        {{ alertTitle }}
       </div>
       <div v-if="submitMsg" class="submit-alert__subtitle">
        {{ submitMsg }}
       </div>
      </div>
     </div>

     <!-- รายการรายงาน -->
     <ul v-if="submitMsg || (submitItems && submitItems.length > 0)" class="submit-alert__list">
      <li
       v-for="item in submitItems"
       :key="item.reportType + item.status + (item.reason || '')"
       class="submit-alert__item">
       <div class="submit-alert__item-main">
        <span class="submit-alert__label">
         {{$t(item.label)}} 
        </span>
        <span
         class="submit-alert__status"
         :class="'submit-alert__status--' + item.status.toLowerCase()">
         {{ item.statusLabel }}
        </span>
       </div>

       <div v-if="item.reason" class="submit-alert__reason">
        {{ item.reason }}
       </div>
      </li>
     </ul>
    </CAlert>

    <!-- Email (To selectable) & CC (chips) -->
    <!-- <CRow class="mb-0">
          <CCol md="6" class="mb-2">
            <label for="toEmail">
              {{ $t('email') || 'อีเมลผู้รับ (อีเมลร้าน)' }}
              <span class="text-danger">*</span>
            </label>

            <select
              id="toEmail"
              v-model="form.toEmail"
              class="form-control"
              style="height: calc(1.5em + 0.95rem + 2px);"
              :disabled="loading"
            >
              <option value="">
                {{ $t('selectEmail') || 'เลือกอีเมลปลายทาง' }}
              </option>
              <option
                v-for="email in toEmailOptions"
                :key="email"
                :value="email"
              >
                {{ email }}
              </option>
            </select>

            <small v-if="errors.toEmail" class="text-danger">
              {{ errors.toEmail }}
            </small>
            <small class="text-muted d-block">
              {{ $t('selectShopEmailHint') ||'เลือกอีเมลของร้านที่จะใช้รับรายงาน (mock ข้อมูลในระบบไว้ชั่วคราว)'}}
            </small>
          </CCol>

          <CCol md="6" class="mb-2">
            <label for="ccChips">
              CC ({{ $t('optional') || 'ไม่บังคับ' }})
            </label>
            <div class="cc-token-input" @click="focusCc">
              <ul class="cc-chips" id="ccChips">
                <li
                  v-for="(t, i) in ccTokens"
                  :key="t.id"
                  class="chip"
                  :class="t.valid ? 'is-valid' : 'is-invalid'"
                >
                  <span class="avatar">{{ t.initial }}</span>
                  <span class="label">{{ t.label }}</span>
                  <button type="button" class="btn-x" @click.stop="removeCc(i)">
                    ×
                  </button>
                </li>
                <input
                  ref="ccInput"
                  v-model.trim="ccDraft"
                  class="chip-input"
                  type="text"
                  :placeholder="$t('typeEmailAndPressEnter') ||'พิมพ์อีเมลแล้วกด Enter (,)'"
                  @keydown.enter.prevent="commitCc"
                  @keydown.space.prevent="commitCc"
                  @keydown.,.prevent="commitCc"
                  @blur="commitCc"
                />
              </ul>
            </div>
            <small class="text-muted">
              {{$t('ccHint') || 'รองรับหลายอีเมล กด Enter หรือเครื่องหมาย "," เพื่อเพิ่มเป็นแท็ก'}}
            </small>
            <small v-if="errors.cc" class="text-danger d-block">
              {{ errors.cc }}
            </small>
          </CCol>
        </CRow> -->

    <!-- Report types + statuses -->
    <div class="mb-3">
     <div class="fw-semibold mb-2">
      {{ $t("reportTypes") || "ประเภทรายงาน" }}
      <span class="text-danger">*</span>
     </div>
     <small class="d-block text-muted mb-2">
      {{ $t("reportMultiSelectHint") || "สามารถเลือกได้มากกว่า 1 รายการ" }}
     </small>

     <div class="row">
      <div
       class="col-12 col-md-6 mb-2"
       v-for="rt in reportOptions"
       :key="rt.value">
       <div class="rounded d-flex align-items-center justify-content-between">
        <CButton
         color="success"
         type="button"
         class="w-100 text-start"
         :variant="!isActive(rt.value) ? 'outline' : ''"
         @click="toggleReport(rt.value)"
         :disabled="isReportDisabled(rt.value)">
         <div class="d-flex align-items-center justify-content-between m-1">
          <div>
           <div class="fw-semibold"> {{ $t(rt.label) }} </div>
          </div>
          <!-- <span
                      class="badge ml-2"
                      :class="statusBadgeClass(rtStatus(rt.value))"
                    >
                      {{ displayStatus(rtStatus(rt.value)) }}
                    </span> -->
         </div>
        </CButton>
       </div>
      </div>
     </div>
     <small class="d-block text-muted">
      {{
       $t("reportStatusRule") ||
       'หากรายงานอยู่ในสถานะ "ร้องขอ" จะไม่สามารถเลือกได้จนกว่างานเดิมจะสำเร็จ'
      }}
     </small>
     <small v-if="errors.reportTypes" class="text-danger">
      {{ errors.reportTypes }}
     </small>
    </div>

    <!-- Date Range Picker -->
    <CRow>
     <div class="ml-2">
      <label>
       {{ $t("date") || "ช่วงวันที่" }}
       <span class="text-danger">*</span>
      </label>
     </div>
     <CCol md="4" lg="4">
      <v-date-picker v-model="selectedDate" :locale="getCurrentLang()" >
         <template #default="{ inputValue, inputEvents }">
          <input :value="inputValue" v-on="inputEvents"  class="form-control"/>
        </template>
      </v-date-picker>
      <!-- <VueDatePicker
        v-model="selectedDate"
        type="date"
       :locale="getDateLocale()"
        format="DD/MM/YYYY"
        value-type="YYYY-MM-DD"
        class="form-control text-dark"
        @change="onChangeDate"
      /> -->
      <!-- <v-md-date-range-picker
       id="exportDateRange"
       opens="left"
       :locale="getCurrentLang()"
       :currentLang="getCurrentLang()"
       :start-date="form.dateFrom"
       :end-date="form.dateTo"
       :presets="updatePresetsRangePicker()"
       @change="handleChange">
       <template slot="input" class="activator-wrapper">
        <div id="exportDateInput" class="custom-file text-dark">
         <div role="group" class="input-date form-group">
          <div class="input-group" style="min-width: 250px">
           <input
            id="exportDateInputField"
            type="text"
            readonly
            class="form-control input-group-text"
            :value="displayDateRange"
            style="
             -webkit-box-shadow: unset;
             box-shadow: unset;
             font-weight: normal;
             font-size: inherit;
             cursor: pointer;
             color: #4f5d73;
            " />
           <div class="input-group-append">
            <span
             id="exportDateInputIcon"
             class="input-group-icon"
             style="color: silver; display: flex; align-items: center">
             <i class="fi fi-rr-calendar-days" aria-hidden="true"></i>
            </span>
           </div>
          </div>
         </div>
        </div>
       </template>
      </v-md-date-range-picker> -->
      <div>
       <!-- <small class="text-muted">
        {{
         $t("dateRangeHint") ||
         "ช่วงเวลาต้องไม่เกิน 31 วัน และวันที่สิ้นสุดต้องไม่ก่อนวันที่เริ่มต้น"
        }}
       </small> -->
       <small v-if="errors.dateRange" class="text-danger d-block">
        {{ errors.dateRange }}
       </small>
      </div>
     </CCol>
    </CRow>

    <div class="d-flex justify-content-end gap-2 mt-2">
     <!-- <CButton
            color="secondary"
            variant="outline"
            :disabled="loading"
            @click="resetForm"
          >
            {{ $t('reset') || 'ล้างค่า' }}
          </CButton> -->
     <!-- <CButton
            color="success"
            :disabled="!canSubmit || loading"
            @click="openConfirm"
            class="ml-3 p-2"
          >
            {{loading ? $t('processing') || 'กำลังส่งออก...': $t('exportByEmail') || 'ร้องขอเอกสาร'}}
          </CButton> -->
     <CButton
      color="primary"
      :disabled="!canSubmit || loading"
      @click="openConfirm"
      class="p-2">
      {{
       loading
        ? $t("processing") || "กำลังร้องขอ..."
        : $t("exportByEmail") || "ร้องขอเอกสาร"
      }}
     </CButton>
    </div>
   </CCardBody>
  </CCard>
  <CCard>
   <CCardBody>
    <!-- ========== ประวัติการส่งออกรายงาน ========== -->
    <div class="mt-3">
     <div class="d-flex align-items-center justify-content-between mb-1">
      <h5 class="mb-0">
       {{ $t("exportHistory") || "ประวัติการส่งออกรายงาน" }}
      </h5>

      <CButton
       size="sm"
       color="light"
       class="btn-refresh-history d-inline-flex align-items-center position-relative"
       :disabled="loadingExportJobs"
       @click="refreshExportHistory">
       <!-- default icon -->
       <!-- <CSpinner
                v-if="loadingExportJobs"
                color="secondary"
                size="sm"
              /> -->

       <!-- loading spinner -->
       <i
        v-if="!loadingExportJobs"
        class="fi fi-rr-rotate-right"
        aria-hidden="true"></i>
      </CButton>
     </div>
     <small class="text-muted d-block mb-1">
      {{
       $t("exportHistoryDesc") || "แสดงรายการที่เคยร้องขอส่งออกรายงานย้อนหลัง"
      }}
     </small>
     <div class="usage-steps mb-3">
        <div class="usage-header">
          <i class="fi fi-rr-info mr-2"></i>
          <span class="usage-title">
            {{ $t("exportReportUsageTitle") }}
          </span>
        </div>

        <ul class="usage-list">
          <li
            v-for="(rule, i) in $t('exportReportUsageRules')"
            :key="i"
            class="usage-item"
          >
            <span class="usage-bullet">•</span>
            <span class="usage-text">{{ rule }}</span>
          </li>
        </ul>
      </div>
     <div class="row align-items-end mb-2 filter-row">
      <div class="col-md-3 col-6 ">
       <label class="small mb-1">
        {{ $t("filterReportType") || "กรองตามประเภทรายงาน" }}
       </label>
       <select v-model="filter.reportType" class="form-control filter-control">
        <option
         v-for="opt in reportFilterOptions"
         :key="opt.value"
         :value="opt.value">
         {{ $t(opt.label) }}
        </option>
       </select>
      </div>

      <div class="col-md-3 col-6" >
       <label class="small mb-1">
        {{ $t("filterStatus") || "กรองตามสถานะ" }}
       </label>
       <select v-model="filter.status" class="form-control filter-control">
        <option
         v-for="opt in statusFilterOptions"
         :key="opt.value"
         :value="opt.value">
         {{ $t(opt.label) }}
        </option>
       </select>
      </div>

      <!-- กรองตามช่วงเวลาที่สร้างเอกสาร -->
      <div class="col-md-4 col-8">
       <label class="small mb-1">
        {{ $t("filterCreatedRange") || "ช่วงเวลาที่สร้างเอกสาร" }}
       </label>
       <div>
        <v-date-picker
          v-model="historyRange"
          is-range
          :locale="getCurrentLang()"
          :popover="{ visibility: 'click', placement: 'bottom-start' }"
          @input="handleHistoryDateChange"
        >
          <template v-slot="{ inputValue, togglePopover }">
            <div
              class="filter-date-wrapper text-dark"
              @click="togglePopover"
              style="width: 100%"
            >
              <div class="input-group">
                <input
                  type="text"
                  readonly
                  class="form-control input-group-text filter-control"
                  :value="formatHistoryRange(inputValue)"
                  style="
                    box-shadow: unset;
                    font-weight: normal;
                    cursor: pointer;
                    color: #4f5d73;
                  "
                />
                <div class="input-group-append">
                  <span
                    class="input-group-icon"
                    style="color: silver; display: flex; align-items: center"
                  >
                    <i class="fi fi-rr-calendar-days"></i>
                  </span>
                </div>
              </div>
            </div>
          </template>
        </v-date-picker>

       </div>
      </div>

      <div class="col-md-2  col-4 d-flex">
       <CButton
        size="sm"
        color="secondary"
        variant="outline"
        block
        class="filter-control filter-btn"
        @click="resetHistoryFilter">
        {{ $t("clearFilter") || "ล้างตัวกรอง" }}
       </CButton>
      </div>
     </div>
     <DataTable
      :items="exportJobs"
      :fields="exportJobsFields"
      hover
      striped
      responsive
      :loading="loadingExportJobs">
      <!-- ชื่อรายงาน -->
      <template #reportName="{ item }">
       <td class="text-left text-dark">
        {{ $t(displayReport(item.reportType)) }}
       </td>
      </template>

      <!-- วันที่ร้องขอ -->
      <template #requestedAt="{ item }">
       <td class="text-left text-dark">
        {{ formatDateTime(item.requestedAt) }}
       </td>
      </template>

      <!-- ช่วงวันที่ที่ request -->
      <template #dateRange="{ item }">
       <td class="text-left text-dark">
        {{ formatDateRange(item.dateFrom, item.dateTo) }}
       </td>
      </template>
      <template #expiredAt="{ item }">
       <td class="text-left text-dark">
        {{ item.expiredAt ? formatDateTime(item.expiredAt) : "" }}
       </td>
      </template>
      <!-- สถานะ -->
      <template #status="{ item }">
       <td class="text-center text-dark">
        <!-- รอ -->
        <span
         v-if="item.status === 'PENDING'"
         class="status-chip status-chip-pending">
         {{ $t("pendingQueue")  }}
        </span>

        <!-- กำลังทำงาน -->
        <span
         v-else-if="item.status === 'PROCESSING'"
         class="status-chip status-chip-processing">
         {{ $t("processing") || "กำลังสร้างไฟล์" }}
        </span>

        <!-- พร้อมดาวน์โหลด -->
        <button
         v-else-if="item.status === 'COMPLETED'"
         type="button"
         class="status-chip status-chip-download"
         @click.stop="downloadReport(item)">
         {{ $t("download") || "ดาวน์โหลด" }}
        </button>

        <!-- หมดอายุ -->
        <span
         v-else-if="item.status === 'EXPIRED'"
         class="status-chip status-chip-expired">
         {{ $t("expiredStatus") || "หมดอายุ" }}
        </span>

        <!-- ล้มเหลว -->
        <span
         v-else-if="item.status === 'FAILED'"
         class="status-chip status-chip-failed">
         {{ $t("failed") || "ล้มเหลว" }}
        </span>

        <!-- ถูกยกเลิก -->
        <span
         v-else-if="item.status === 'CANCELED'"
         class="status-chip status-chip-canceled">
         {{ $t("canceled") || "ถูกยกเลิก" }}
        </span>

        <!-- ไม่รู้จัก -->
        <!-- <span class="status-chip status-chip-unknown">
                  {{ item.status }}
                </span> -->
       </td>
      </template>

      <!-- ตอนไม่มีข้อมูล -->
      <template #no-items-view>
       <div class="text-center my-4">
        <h5 style="color: #ced2d8">
         {{ $t("noHistory") || "ยังไม่มีประวัติการส่งออกรายงาน" }}
        </h5>
       </div>
      </template>
      <template #actions="{ item }">
       <td class="text-right">
        <CDropdown placement="bottom-end">
         <template #toggler>
          <CHeaderNavLink class="p-0">
           <div>
            <i class="fi fi-rr-menu-dots-vertical"></i>
           </div>
          </CHeaderNavLink>
         </template>
         <CDropdownMenu>
          <CDropdownItem
           v-if="item.status === 'COMPLETED'"
           @click.stop="downloadReport(item)">
           <i class="fi fi-rr-download mr-2"></i>
           {{ $t('download') }}
          </CDropdownItem>

          <CDropdownItem
           class="text-danger"
           v-if="canDeleteJob(item)"
           @click.stop="openDeleteConfirm(item)">
           <i class="fi fi-rr-trash mr-2"></i>
           {{ $t('cancel') }}
          </CDropdownItem>
         </CDropdownMenu>
        </CDropdown>
       </td>
      </template>
     </DataTable>
     <pagination
      :meta_data="meta_data"
      v-on:next="fetchExportJobs"></pagination>
    </div>
   </CCardBody>
  </CCard>
  <!-- Confirm Modal -->
  <CModal
   color="success"
   :show.sync="visibleConfirm"
   :title="$t('confirmExport') || 'ยืนยันการร้องขอข้อมูล'"
   centered
   id="confirm-export-modal">
   <div class="confirm-summary mb-3">
    <div class="confirm-title">
     {{ $t("pleaseReviewBeforeConfirm") || "กรุณาตรวจสอบรายละเอียดก่อนยืนยัน" }}
    </div>

    <div class="confirm-grid">
     <!-- <div class="label">{{ $t('email') || 'อีเมล' }}</div>
          <div class="value">{{ form.toEmail || '-' }}</div>

          <div class="label">CC</div>
          <div class="value">
            <template v-if="ccArray.length">
              <span
                class="cc-pill"
                v-for="(cc, i) in ccArray"
                :key="cc + i"
              >
                {{ cc }}
              </span>
            </template>
            <span v-else>-</span>
          </div> -->

     <div class="label">
      {{ $t("reportTypes") || "ประเภทรายงาน" }}
     </div>
     <div class="value">
      {{ form.reportTypes.length? form.reportTypes.map(t => $t(displayReport(t))).join(", "): "-"}}
     </div>

     <div class="label">
      {{ $t("branches") || "สาขา" }}
     </div>
     <div class="value">
      {{ $t("allBranches") || "รวมทุกสาขา" }}
     </div>

     <div class="label">
      {{ $t("dateFrom") || "วันที่เริ่มต้น" }}
     </div>
     <div class="value">
      {{ selectedDate || "-" }}
     </div>

     <div class="label">
      {{ $t("dateTo") || "วันที่สิ้นสุด" }}
     </div>
     <div class="value">
      {{ selectedDate || "-" }}
     </div>
    </div>

    <div v-if="confirmError" class="error-text">
     {{ confirmError }}
    </div>
   </div>

   <template slot="footer">
    <CButton
     color="secondary"
     variant="outline"
     :disabled="loading"
     @click="visibleConfirm = false">
     {{ $t("cancel") || "ยกเลิก" }}
    </CButton>
    <CButton color="success" :disabled="loading" @click="submit">
     {{
      loading
       ? $t("processing") || "กำลังดำเนินการ..."
       : $t("confirmAndExport") || "ยืนยันและส่งออก"
     }}
    </CButton>
   </template>
  </CModal>
  <CModal
   color="danger"
   :show.sync="visibleDeleteConfirm"
   :title="$t('confirmDeleteJob') || 'ยืนยันยกเลิกรายการ'"
   centered>
   <div>
    <div class="mb-2">
     {{
      $t("deleteJobConfirmMessageWarm") ||
      "หากยกลเอกรายการนี้ จะไม่สามารถดาวน์โหลดไฟล์จากรายการเดิมได้"
     }}
    </div>
    <div class="text-muted small">
      {{ displayReport(deletingItem && deletingItem.reportType) }} •
      {{ formatDateRange(
        deletingItem && deletingItem.dateFrom,
        deletingItem && deletingItem.dateTo
      ) }}
    </div>
   </div>

   <template slot="footer">
    <CButton
     color="secondary"
     variant="outline"
     @click="visibleDeleteConfirm = false">
     {{ $t("cancel") || "ยกเลิก" }}
    </CButton>
    <CButton color="danger" :disabled="loadingDeleteJobId" @click="deleteJob">
     {{ $t("confirm") || "ยืนยัน" }}
    </CButton>
   </template>
  </CModal>
 </div>
  <div v-else>
      <access-data></access-data>
    </div>
 </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import util from "@/util/util";
import report from "@/services/report";
import DataTable from "@/containers/DataTable";
import Pagination from "@/containers/Pagination";
import permis from "@/util/permission";
// import '@/assets/styles/promotion.css'
// import 'vue2-datepicker/index.css'
// import DatePicker from "vue2-datepicker";

// import VueTimepicker from 'vue2-timepicker'
export default {
 name: "ExportReportsByEmail",
 components: {
  DataTable,
  Pagination,
  // VueDatePicker: DatePicker,
 },
 data() {
  const today = moment().format("YYYY-MM-DD");
  const oneMonthAgo = moment().subtract(1, "month").format("YYYY-MM-DD");
   const yesterday = moment().subtract(1, "day").format("YYYY-MM-DD");

  return {
   selectedDate: today,
   loading: false,
   visibleConfirm: false,
   submitMsg: "",
   confirmError: "",
   alertColor: "info", // success | warning | danger | info
   alertMode: "export",
   showSubmitAlert: false,
   hasError: false,
   hasSuccess: false,
   submitError: "",
   successMsg: "",
   form: {
    reportTypes: [],
    dateFrom: today,
    dateTo:  today,
    toEmail: "",
   },
   // exportJobs: [],
   exportJobs: [],
   loadingExportJobs: false,
   errors: { toEmail: "", reportTypes: "", dateRange: "", cc: "" },

   // CC chips
   ccTokens: [], // [{ id, email, label, initial, valid }]
   ccDraft: "",

   // รายชื่ออีเมลปลายทาง (mock)
   toEmailOptions: [],

   // รายงาน + สถานะ
   reportOptions: [
    {
     value: "RECEIPT_HISTORY",
     label: 'report.transaction',
     desc: this.$t("salesHistoryDesc") || "บันทึกการขายทั้งหมดตามช่วงวันที่",
    },
    // {
    //  value: "PAYMENT_METHOD_SUMMARY",
    //  label: "paymentReport",
    //  desc: this.$t("paymentsDesc") || "ยอดรับชำระ / ช่องทางการชำระ",
    // },
    {
     value: "RECEIPT_ITEM_SOLD",
     label: "salesReportByBill",
     desc: this.$t("salesByBillDesc") || "รายการขายแยกตามบิล",
    },
   ],
   meta_data: {
    last_page: 1,
    current_page: 1,
    prev_page_url: null,
    items: 0,
    limit: 10,
    itemCount: null,
   },
   filter: {
    reportType: "ALL",
    status: "ALL",
    createdFrom: null, // ⬅ ค่า default
    createdTo: null,
   },
   statusFilterOptions: [
    { value: "ALL", label: "allStatus" || "ทุกสถานะ" },
    { value: "PENDING", label: "pending" || "รอประมวลผล" },
    { value: "PROCESSING", label: "processing" || "กำลังสร้างไฟล์" },
    { value: "COMPLETED", label: "completed" || "สำเร็จ (ดาวน์โหลดได้)" },
    { value: "EXPIRED", label: "expiredStatus" || "หมดอายุ" },
    { value: "FAILED", label: "failed" || "ล้มเหลว" },
    { value: "CANCELED", label: "canceled" || "ถูกยกเลิก" },
   ],
   historyRange: null,

   // เก็บสถานะรายงานล่าสุด
   statuses: {}, // { key: 'READY' | 'REQUESTED' | 'PROCESSING' | 'DONE' | 'FAILED' }
   autoRefreshTimer: null,
   submitItems: [],
   visibleDeleteConfirm: false,
   deletingItem: null,
   loadingDeleteJobId: null,
   
  };
 },
 mounted() {
    if (!this.filter.createdFrom || !this.filter.createdTo) {
      const today = new Date()

      this.historyRange = {
        start: today,
        end: today,
      }

      this.filter.createdFrom = moment(today).format('YYYY-MM-DD')
      this.filter.createdTo = moment(today).format('YYYY-MM-DD')
    }
  },
 computed: {
  ...mapGetters(["shops", "date"]),
  alertTitle() {
    // ✅ โหมด "ยกเลิก"
    if (this.alertMode === "cancel") {
      if (this.alertColor === "success") {
        return this.$t("cancelJobSuccessTitle") || "ยกเลิกรายการสำเร็จ";
      }
      if (this.alertColor === "danger") {
        return this.$t("cancelJobFailedTitle") || "ยกเลิกรายการไม่สำเร็จ";
      }
      return this.$t("cancelJobInfoTitle") || "สถานะการยกเลิกรายการ";
    }

    // ✅ โหมดเดิม "สร้างคำขอรายงาน"
    if (this.alertColor === "success") {
      return this.$t("exportJobCreated") || "สร้างคำขอรายงานสำเร็จ";
    }
    if (this.alertColor === "warning") {
      return this.$t("exportJobPartial") || "บางรายงานมีข้อจำกัดในการสร้างคำขอ";
    }
    if (this.alertColor === "danger") {
      return this.$t("exportJobFailed") || "ไม่สามารถสร้างคำขอรายงานได้";
    }
    return this.$t("exportJobInfo") || "สถานะการสร้างคำขอรายงาน";
  },
  alertIconClass() {
   switch (this.alertColor) {
    case "success":
     return "fi fi-rr-check-circle submit-alert__icon--success";
    case "warning":
     return "fi fi-rr-triangle-warning submit-alert__icon--warning";
    case "danger":
     return "fi fi-rr-circle-xmark submit-alert__icon--danger";
    default:
     return "fi fi-rr-info submit-alert__icon--info";
   }
  },
  filteredExportJobs() {
   return this.exportJobs.filter((job) => {
    const matchReport =
     this.filter.reportType === "ALL" ||
     job.reportType === this.filter.reportType;

    const matchStatus =
     this.filter.status === "ALL" || job.status === this.filter.status;

    return matchReport && matchStatus;
   });
  },
  reportFilterOptions() {
   return [
    { value: "ALL", label: this.$t("allReports") || "รายงานทั้งหมด" },
    ...this.reportOptions.map((r) => ({
     value: r.value,
     label: r.label,
    })),
   ];
  },
  isPermission() {
      return permis.findPermissionRead("exportreportfiles", this.$route.path);
      // return true
    },

  shopEmailResolved() {
   return localStorage.getItem("shopEmail") || "";
  },
  ccArray() {
   return this.ccTokens.filter((t) => t.valid).map((t) => t.email);
  },
  canSubmit() {
   return !!this.form.toEmail && this.validate(true);
  },
  displayDateRange() {
   if (!this.form.dateFrom || !this.form.dateTo) return "";
   const start = moment(this.form.dateFrom).format("DD/MM/YYYY");
   const end = moment(this.form.dateTo).format("DD/MM/YYYY");
   return `${start} - ${end}`;
  },
  exportJobsFields() {
   return [
    {
     key: "requestedAt",
     label: this.$t("requestedAt") || "วันที่ร้องขอ",
    },
    {
     key: "reportName",
     label: this.$t("reportName") || "ชื่อรายงาน",
    },
    {
     key: "dateRange",
     label: this.$t("requestedRange") || "ช่วงเวลาที่ร้องขอ",
    },
    {
     key: "expiredAt",
     label: this.$t("expired") || "วันหมดอายุ",
    },
    {
     key: "status",
     label: this.$t("requestStatus") || "สถานะการร้องขอ",
     _classes: "text-center",
    },
    { key: "actions", label: "", _classes: "text-center", _style: "width:5%;" },
   ];
  },
  historyDisplayDateRange() {
   const { createdFrom, createdTo } = this.filter;
   if (!createdFrom || !createdTo) return "";
   return (
    moment(createdFrom).format("DD/MM/YYYY") +
    " - " +
    moment(createdTo).format("DD/MM/YYYY")
   );
  },
  displaySingleDate() {
    return this.form.dateFrom
      ? moment(this.form.dateFrom).format("DD/MM/YYYY")
      : "";
  },
 },
 watch: {
  "filter.reportType"() {
   // เปลี่ยน filter → กลับไปหน้าแรกของ history
   this.fetchExportJobs(1);
  },
  "filter.status"() {
   this.fetchExportJobs(1);
  },
 },
 created() {
  this.prefillDateFromStore();
  // this.fetchStatuses()
  this.initEmails();
  this.fetchExportJobs();
  this.startAutoRefresh();
 },
 beforeDestroy() {
  if (this.autoRefreshTimer) {
   clearInterval(this.autoRefreshTimer);
  }
 },
 methods: {
  ...util,
  getDateLocale() {
      return this.$i18n.locale
  },
  formatHistoryRange(inputValue) {
    if (!inputValue?.start || !inputValue?.end) return ''
    return (inputValue.start +' - ' +inputValue.end
    )
  },
  onChangeDate(val) {
    console.log(val);
    
    if (!val) return;
    // val = YYYY-MM-DD
    this.form.dateFrom = val;
    this.form.dateTo = val;
    this.selectedDate = val;
    this.validateDateRange();
  },
  hasDuplicateRequest(reportType, startDate, endDate) {
   const sd = moment(startDate).format("YYYY-MM-DD");
   const ed = moment(endDate).format("YYYY-MM-DD");

   return this.exportJobs.some((j) => {
    const sameType = j.reportType === reportType;
    const sameRange =
     moment(j.dateFrom).format("YYYY-MM-DD") === sd &&
     moment(j.dateTo).format("YYYY-MM-DD") === ed;

    // ถือว่า “ยังคาอยู่” = ห้าม request ซ้ำ
    const st = (j.status || "").toUpperCase();
    const blockingStatuses = ["PENDING", "PROCESSING", "COMPLETED"]; // ปรับได้
    return sameType && sameRange && blockingStatuses.includes(st);
   });
  },
  canDeleteJob(item) {
    const st = (item?.status || "").toUpperCase();
    return !!item?.id && ["PENDING", "COMPLETED", "FAILED"].includes(st);
  },

  openDeleteConfirm(item) {
   this.deletingItem = item;
   this.visibleDeleteConfirm = true;
  },

  async deleteJob() {
    if (!this.deletingItem?.id) return;
    const st = (this.deletingItem?.status || "").toUpperCase();
    if (!["PENDING", "COMPLETED", "FAILED"].includes(st)) return;

    this.loadingDeleteJobId = this.deletingItem.id;

    try {
      const rawShopId = localStorage.getItem("shopObjectId");
      const headers = {
        shopObjectId: this.sanitizeShopObjectId
          ? this.sanitizeShopObjectId(rawShopId)
          : rawShopId,
      };

      // ✅ CANCEL JOB (ตาม Postman)
      const res = await report({
        url: `/api/v3.0/jobs/cancel`,
        method: "PATCH",
        headers,
        data: { jobId: this.deletingItem.id },
      });

      if (!res || res.status >= 400) {
        throw new Error(`Cancel job failed (${res?.status || "ERR"})`);
      }

      // ✅ ทางเลือก A: อัปเดตสถานะใน list (แนะนำ)
      this.exportJobs = this.exportJobs.map(j =>
        j.id === this.deletingItem.id ? { ...j, status: "CANCELED" } : j
      );

      // ✅ ทางเลือก B: ซ่อนออกจาก list (ถ้าต้องการเหมือน “ลบ”)
      // this.exportJobs = this.exportJobs.filter(j => j.id !== this.deletingItem.id);

      this.alertColor = "success";
      this.submitMsg = this.$t("cancelJobSuccess") || "ยกเลิกรายการสำเร็จ";
      this.submitItems = [];
      this.showSubmitAlert = true;
      setTimeout(() => (this.showSubmitAlert = false), 4000);

      this.visibleDeleteConfirm = false;
      this.deletingItem = null;

      // โหลด history ใหม่ก็ได้ เผื่อ backend ส่งสถานะอื่นกลับมา
      this.fetchExportJobs(this.meta_data.current_page || 1);
    } catch (e) {
      this.alertColor = "danger";
      this.submitMsg = this.$t("cancelFailed") || "ยกเลิกรายการไม่สำเร็จ กรุณาลองใหม่";
      this.submitItems = [];
      this.showSubmitAlert = true;
      setTimeout(() => (this.showSubmitAlert = false), 5000);
    } finally {
      this.alertMode = "cancel";
      this.loadingDeleteJobId = null;
    }
  },
  handleHistoryDateChange(range) {
   if (!range?.start || !range?.end) return

    this.historyRange = range

    this.filter.createdFrom = moment(range.start).format('YYYY-MM-DD')
    this.filter.createdTo = moment(range.end).format('YYYY-MM-DD')
   this.fetchExportJobs(1); // โหลดหน้าแรกใหม่
  },
  resetHistoryFilter() {
   this.filter.reportType = "ALL";
   this.filter.status = "ALL";
   this.filter.createdFrom = "";
   this.filter.createdTo = "";
   this.fetchExportJobs(1);
  },
  refreshExportHistory() {
   this.fetchExportJobs(this.meta_data.current_page || 1);
  },

  startAutoRefresh() {
   // กันซ้ำ
   if (this.autoRefreshTimer) {
    clearInterval(this.autoRefreshTimer);
   }
   this.autoRefreshTimer = setInterval(() => {
    // ใช้หน้าปัจจุบัน
    this.fetchExportJobs(this.meta_data.current_page || 1);
   }, 60000); // 30 วินาที
  },

  getCurrentLang() {
   if (this.$i18n && this.$i18n.locale) {
    return this.$i18n.locale;
   }
   return "th";
  },

  updatePresetsRangePicker() {
   return [
    {
     label: this.$t("today") || "วันนี้",
     range: [moment().startOf("day"), moment().endOf("day")],
    },
    {
     label: this.$t("yesterday") || "เมื่อวานนี้",
     range: [
      moment().subtract(1, "day").startOf("day"),
      moment().subtract(1, "day").endOf("day"),
     ],
    },
    {
     label: this.$t("last7days") || "7 วันที่ผ่านมา",
     range: [moment().subtract(6, "day").startOf("day"), moment().endOf("day")],
    },
    {
     label: this.$t("thismonth") || "เดือนนี้",
     range: [moment().startOf("month"), moment().endOf("month")],
    },
   ];
  },

  // callback ตอนเลือกช่วงวันที่ใหม่
  handleChange(values) {
  //  if (!Array.isArray(values) || values.length < 2) return;
  //  const [startDate, endDate] = values;
  //  this.form.dateFrom = moment(startDate).format("YYYY-MM-DD");
  //  this.form.dateTo = moment(endDate).format("YYYY-MM-DD");
  //  this.validateDateRange();
    if (!Array.isArray(values) || values.length < 2) return;
    const [startDate] = values; // ✅ ใช้แค่ start

    const d = moment(startDate).format("YYYY-MM-DD");
    this.form.dateFrom = d;
    this.form.dateTo = d; // ✅ บังคับให้เหมือนกัน
    this.validateDateRange();
  },

  // ---------- Email list (mock) ----------
  initEmails() {
   const primary = this.shopEmailResolved;
   const mockOthers = [
    "owner@example.com",
    "manager@example.com",
    "accounting@example.com",
   ];

   const list = [primary, ...mockOthers].filter(Boolean);
   this.toEmailOptions = Array.from(new Set(list));

   if (!this.form.toEmail) {
    this.form.toEmail = primary || this.toEmailOptions[0] || "";
   }
  },

  isActive(value) {
   return this.form.reportTypes.includes(value);
  },
  toggleReport(value) {
   const idx = this.form.reportTypes.indexOf(value);
   if (idx >= 0) {
    this.form.reportTypes.splice(idx, 1);
   } else {
    this.form.reportTypes.push(value);
   }
  },

  // ---------- Date ----------
  prefillDateFromStore() {
   const startAt = moment(String(this.date.start)).format("YYYY-MM-DD");
   const endAt = moment(String(this.date.end)).format("YYYY-MM-DD");
   this.form.dateFrom = startAt;
   this.form.dateTo = endAt;
  },
  validateDateRange() {
   const { dateFrom, dateTo } = this.form;
   if (!dateFrom || !dateTo) {
    this.errors.dateRange = "กรุณาเลือกช่วงวันที่ให้ครบ (ไม่เกิน 31 วัน)";
    return this.errors.dateRange;
   }
   const from = new Date(dateFrom);
   const to = new Date(dateTo);
   if (isNaN(from.getTime()) || isNaN(to.getTime())) {
    this.errors.dateRange = "รูปแบบวันที่ไม่ถูกต้อง";
    return this.errors.dateRange;
   }
   if (to < from) {
    this.errors.dateRange = "วันที่สิ้นสุดต้องไม่น้อยกว่าวันที่เริ่มต้น";
    return this.errors.dateRange;
   }
  //  if (dateFrom !== dateTo) {
  //     this.errors.dateRange = this.$t("exportOnlyOneDay") || "สามารถเลือกได้เพียง 1 วันเท่านั้น";
  //     return this.errors.dateRange;
  //   }
   const diffDays =
    Math.ceil((to.getTime() - from.getTime()) / (1000 * 60 * 60 * 24)) + 1;
   if (diffDays > 31) {
    this.errors.dateRange = "ช่วงเวลายาวเกิน 31 วัน กรุณาปรับช่วง";
    return this.errors.dateRange;
   }
   this.errors.dateRange = "";
   return "";
  },

  // ---------- CC chips ----------
  focusCc() {
   this.$refs.ccInput?.focus();
  },
  isValidEmail(v) {
   return /[^\s@]+@[^\s@]+\.[^\s@]+/.test(v);
  },
  parseToken(str) {
   const s = (str || "").trim().replace(/,$/, "");
   if (!s) return null;
   const m = s.match(/^(.*)<([^>]+)>$/);
   let label = s;
   let email = s;
   if (m && m[2]) {
    email = m[2].trim();
    label = (m[1] || "").trim() || email;
   }
   const valid = this.isValidEmail(email);
   return {
    id: `${Date.now()}_${Math.random().toString(36).slice(2)}`,
    email,
    label,
    initial: (label || email).trim().charAt(0).toUpperCase(),
    valid,
   };
  },
  commitCc() {
   const parts = this.ccDraft
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
   if (!parts.length) return;
   parts.forEach((p) => {
    const token = this.parseToken(p);
    if (token) this.ccTokens.push(token);
   });
   this.ccDraft = "";
   this.validateCc();
  },
  removeCc(index) {
   this.ccTokens.splice(index, 1);
   this.validateCc();
  },
  validateCc() {
   const bad = this.ccTokens.filter((t) => !t.valid);
   this.errors.cc = bad.length
    ? `อีเมลไม่ถูกต้อง: ${bad.map((b) => b.label).join(", ")}`
    : "";
   return this.errors.cc;
  },

  // ---------- Status ----------
  async fetchStatuses() {
   try {
    const rawShopId = localStorage.getItem("shopObjectId");
    const headers = {
     shopObjectId: this.sanitizeShopObjectId
      ? this.sanitizeShopObjectId(rawShopId)
      : rawShopId,
    };
    const resp = await report({
     url: "/api/v3.0/report/export/status",
     method: "GET",
     params: { scope: "all" },
     headers,
    });
    const data = resp?.data?.data || {};
    this.statuses = data;
   } catch (e) {
    const defaults = {};
    this.reportOptions.forEach((r) => {
     defaults[r.value] = "READY";
    });
    this.statuses = defaults;
   }
  },
  rtStatus(key) {
   return (this.statuses?.[key] || "READY").toUpperCase();
  },
  isReportDisabled(key) {
   const st = this.rtStatus(key);
   return st === "REQUESTED" || st === "PROCESSING";
  },
  statusBadgeClass(status) {
   switch ((status || "").toUpperCase()) {
    case "READY":
     return "badge-success-soft";
    case "REQUESTED":
     return "badge-warning-soft";
    case "PROCESSING":
     return "badge-info-soft";
    case "DONE":
     return "badge-success";
    case "FAILED":
     return "badge-danger";
    default:
     return "badge-secondary";
   }
  },
  displayStatus(status) {
   const s = (status || "").toUpperCase();
   const mapTH = {
    READY: "พร้อมส่งออก",
    REQUESTED: "ร้องขอ",
    PROCESSING: "กำลังประมวลผล",
    DONE: "สำเร็จ",
    FAILED: "ล้มเหลว",
   };
   return mapTH[s] || s;
  },

  // ---------- Validate & Submit ----------
  displayReport(v) {
   const r = this.reportOptions.find((r) => r.value === v);
   return r ? r.label : v;
  },
  resetForm() {
   this.form.reportTypes = [];
   this.ccTokens = [];
   this.ccDraft = "";
   this.submitMsg = "";
   this.confirmError = "";
   this.hasError = false;
   this.hasSuccess = false;
   this.submitError = "";
   this.successMsg = "";
   this.form.toEmail = this.form.toEmail || this.shopEmailResolved || "";
   this.validate(true);
  },
  validate(returnBool = false) {
   this.errors.toEmail = this.form.toEmail ? "" : "กรุณาเลือกอีเมลปลายทาง";
   this.errors.reportTypes = this.form.reportTypes.length
    ? ""
    : "กรุณาเลือกอย่างน้อย 1 ประเภทรายงาน";
   this.validateCc();
   this.validateDateRange();
   const ok = !(
    this.errors.toEmail ||
    this.errors.reportTypes ||
    this.errors.cc ||
    this.errors.dateRange
   );
   return returnBool ? ok : undefined;
  },
  openConfirm() {
   this.validate(true);
   if (
    this.errors.toEmail ||
    this.errors.reportTypes ||
    this.errors.cc ||
    this.errors.dateRange
   )
    return;
   this.visibleConfirm = true;
  },
  jobStatusLabel(status) {
   const s = (status || "").toUpperCase();
   const map = {
    REQUESTED: this.$t("requested") || "ร้องขอแล้ว",
    PENDING: this.$t("pendingQueue") || "รอประมวลผล",
    PROCESSING: this.$t("processing") || "กำลังสร้างไฟล์",
    COMPLETED: this.$t("completed") || "สำเร็จ (ดาวน์โหลดได้)",
    EXPIRED: this.$t("expiredStatus") || "หมดอายุ",
    FAILED: this.$t("failed") || "ล้มเหลว",
    CANCELED: this.$t("canceled") || "ถูกยกเลิก",
    SKIPPED: this.$t("skipped") || "ถูกข้าม",
   };
   return map[s] || s;
  },
  async submit() {
   this.confirmError = "";
   this.submitMsg = "";
   this.submitError = "";
   this.successMsg = "";
   this.hasError = false;
   this.hasSuccess = false;
   this.showSubmitAlert = false;
   this.loading = true;

   try {
    const rawShopId = localStorage.getItem("shopObjectId");
    const uid = localStorage.getItem("shopsUid");

    const headers = {
     shopObjectId: this.sanitizeShopObjectId
      ? this.sanitizeShopObjectId(rawShopId)
      : rawShopId,
    };

    const payload = {
     uid: uid || undefined,
     startDate: this.selectedDate,
     endDate: this.selectedDate,
     // backend รับเป็น string คั่นด้วย comma
     reportType: this.form.reportTypes.join(","),
    };

    const res = await report({
     url: "/api/v3.0/jobs/create",
     method: "POST",
     data: payload,
     headers,
    });

    if (!res || res.status >= 400) {
     throw new Error(`Create jobs failed (${res?.status || "ERR"})`);
    }

    const data = res?.data?.data || {};
    const requestList = data.requestList || [];
    const failedList = data.failedList || [];
    const successList = data.successlist || [];

    const mapLabel = (rt) => this.displayReport(rt); // ใช้ label จาก reportOptions
    const items = [];

    // 1) จาก successlist: job ที่สร้างได้ (PENDING / PROCESSING / ...)
    successList.forEach((item) => {
     items.push({
      reportType: item.reportType,
      label: mapLabel(item.reportType),
      status: (item.status || "").toUpperCase(),
      statusLabel: this.jobStatusLabel(item.status),
      reason: "", // successlist ปกติไม่ค่อยมี reason
     });
    });

    // 2) จาก failedList: SKIPPED / FAILED พร้อม reason
    failedList.forEach((item) => {
     items.push({
      reportType: item.reportType,
      label: mapLabel(item.reportType),
      status: (item.status || "").toUpperCase(),
      statusLabel: this.jobStatusLabel(item.status),
      reason: item.reason || "",
     });
    });

    // 3) เผื่อกรณีไม่มี success/failed แต่มี requestList
    if (!items.length && requestList.length) {
     requestList.forEach((item) => {
      items.push({
       reportType: item.reportType,
       label: mapLabel(item.reportType),
       status: (item.status || "").toUpperCase(),
       statusLabel: this.jobStatusLabel(item.status),
       reason: "",
      });
     });
    }

    this.submitItems = items;

    // ข้อความสั้น ๆ ด้านบน alert
    if (successList.length && !failedList.length) {
     this.submitMsg =
      this.$t("exportJobCreated") ||
      "ระบบรับคำร้องขอรายงานแล้ว รายละเอียดแต่ละรายงานดูได้ด้านล่าง";
    } else if (successList.length && failedList.length) {
     this.submitMsg =
      "สร้างคำขอรายงานบางส่วนสำเร็จ และบางส่วนไม่สามารถสร้างได้ กรุณาตรวจสอบรายละเอียดด้านล่าง";
    } else if (!successList.length && failedList.length) {
     this.submitMsg = "ไม่สามารถสร้างคำขอรายงานได้ตามรายการด้านล่าง";
    } else {
     this.submitMsg =
      "ระบบรับคำร้องขอรายงานแล้ว คุณสามารถติดตามสถานะได้จากด้านล่าง";
    }

    // ---------- set alert color ----------
    if (failedList.length && !data.successlist.length) {
     this.alertColor = "danger";
    } else if (failedList.length && data.successlist.length) {
     this.alertColor = "warning";
    } else {
     this.alertColor = "success";
    }

    this.showSubmitAlert = true;
    setTimeout(() => {
     this.showSubmitAlert = false;
    }, 5000);
    this.visibleConfirm = false;

    // refresh ปุ่มสถานะรายงาน + ตารางประวัติ
    // this.fetchStatuses()
    this.fetchExportJobs(this.meta_data.current_page || 1);
   } catch (err) {
    console.error("submit create jobs error", err);
    this.submitMsg =
     err?.message ||
     this.$t("unexpectedError") ||
     "เกิดข้อผิดพลาดในการสร้างคำขอรายงาน กรุณาลองใหม่อีกครั้ง";
    this.alertColor = "danger";
    this.showSubmitAlert = true;
    this.submitItems = [];
    setTimeout(() => {
     this.showSubmitAlert = false;
    }, 5000);
   } finally {
    this.alertMode = "export";
    this.loading = false;
   }
  },
  formatDateTime(val) {
   if (!val) return "-";
   return moment(val).format("DD/MM/YYYY HH:mm");
  },
  formatDateRange(from, to) {
    if (!from) return "-";
    if (!to || from === to) {
      // ✅ วันเดียว
      return moment(from).format("DD/MM/YYYY");
    }

    // ✅ ช่วงวันที่
    return (
      moment(from).format("DD/MM/YYYY") +
      " - " +
      moment(to).format("DD/MM/YYYY")
    );
  },

  async fetchExportJobs(page = 1) {
   this.loadingExportJobs = true;
   try {
    const rawShopId = localStorage.getItem("shopObjectId");
    const uid = localStorage.getItem("shopsUid");

    const headers = {
     shopObjectId: this.sanitizeShopObjectId
      ? this.sanitizeShopObjectId(rawShopId)
      : rawShopId,
    };

    const params = {
     page,
     limit: this.meta_data.limit || 10,
     uid: uid || undefined,
     // ถ้าอยากใช้ date range เดียวกับฟอร์มด้านบน
    };

    // ⬇ filter reportType ตาม dropdown (ใช้ค่าเดียวกับ reportOptions.value)
    if (this.filter.reportType && this.filter.reportType !== "ALL") {
     params.reportType = this.filter.reportType;
    }

    // ⬇ filter status ตาม dropdown
    if (this.filter.status && this.filter.status !== "ALL") {
     params.status = this.filter.status;
    }
    if (this.filter.createdFrom) {
     params.startDate = this.filter.createdFrom;
    }
    if (this.filter.createdTo) {
     params.endDate = this.filter.createdTo;
    }

    const resp = await report({
     url: "/api/v3.0/jobs/history",
     method: "GET",
     headers,
     params,
    });

    const rows = resp?.data?.data || [];

    this.exportJobs = rows.map((item) => ({
     id: item.jobId,
     reportType: item.reportType, // e.g. 'RECEIPT_HISTORY'
     requestedAt: item.created_at || item.serverTimestamp,
     dateFrom: item.startDate,
     dateTo: item.endDate,
     expiredAt: item.expire,
     status: (item.status || "").toUpperCase(), // PENDING / PROCESSING / ...
     downloadUrl: item.link,
    }));

    const paginate = resp?.data?.paginate || {};

    this.meta_data.items = paginate.items ?? 0;
    this.meta_data.last_page = paginate.pageCount || 1;
    this.meta_data.current_page = paginate.currentPage || page;
    this.meta_data.itemCount = paginate.itemCount ?? paginate.items ?? 0;
    this.meta_data.limit = paginate.perPage || this.meta_data.limit;
   } catch (e) {
    console.error("fetchExportJobs error", e);
    this.exportJobs = [];
    this.meta_data.items = 0;
   } finally {
    this.loadingExportJobs = false;
   }
  },

  downloadReport(item) {
   if (!item || !item.downloadUrl) return;
   // ถ้าอยากกัน double-click หรือ track log ก็ทำเพิ่มได้
   window.open(item.downloadUrl, "_blank");
  },
 },
};
</script>

<style>
/* Soft badge styles */
.badge {
 padding: 0.35rem 0.6rem;
 font-size: 12px;
 border-radius: 999px;
}
.badge-success {
 background: #2eb85c;
 color: #fff;
}
.badge-danger {
 background: #e55353;
 color: #fff;
}
.badge-secondary {
 background: #6c757d;
 color: #fff;
}
.badge-warning-soft {
 background: #fff3cd;
 color: #946c00;
}
.badge-info-soft {
 background: #d1ecf1;
 color: #0c5460;
}
.badge-success-soft {
 background: #e6f7ee;
 color: #208b49;
}

/* CC chips UI */
.cc-token-input {
 display: flex;
 align-items: center;
 min-height: 38px;
 border: 1px solid #d8dbe0;
 border-radius: 0.25rem;
 padding: 4px 8px;
 background-color: #fff;
 cursor: text;
 box-sizing: border-box;
}
.cc-chips {
 display: flex;
 align-items: center;
 flex-wrap: wrap;
 gap: 6px;
 margin: 0;
 padding: 0;
 list-style: none;
 width: 100%;
}
.chip {
 display: flex;
 align-items: center;
 gap: 6px;
 padding: 2px 8px 2px 4px;
 border-radius: 20px;
 border: 1px solid #e5e5e5;
 background: #f8f9fa;
}
.chip.is-valid {
 border-color: #d7f0e5;
 background: #f3fcf8;
}
.chip.is-invalid {
 border-color: #ffd6d6;
 background: #fff2f2;
}
.chip .avatar {
 width: 22px;
 height: 22px;
 border-radius: 50%;
 display: flex;
 align-items: center;
 justify-content: center;
 font-size: 12px;
 font-weight: 700;
 color: #fff;
 background-color: #3abc98;
}
.chip.is-invalid .avatar {
 background-color: #e55353;
}
.chip .label {
 font-size: 13px;
 color: #2b2f33;
}
.chip .btn-x {
 border: none;
 background: transparent;
 cursor: pointer;
 font-size: 14px;
 color: #6c757d;
 padding: 0;
}
.chip .btn-x:hover {
 color: #000;
}
.chip-input {
 flex: 1;
 border: none;
 outline: none;
 background: transparent;
 height: 28px;
 font-size: 14px;
 line-height: 1.5;
 min-width: 120px;
}

/* Confirm summary UI */
.confirm-summary {
 background: #f8f9fa;
 border-radius: 10px;
 padding: 16px 20px;
 border: 1px solid #e9ecef;
}
.confirm-title {
 font-weight: 600;
 color: #333;
 margin-bottom: 16px;
 font-size: 15px;
}
.confirm-grid {
 display: grid;
 grid-template-columns: 160px 1fr;
 grid-row-gap: 12px;
 grid-column-gap: 12px;
 font-size: 14px;
 align-items: start;
}
.confirm-grid .label {
 font-weight: 600;
 color: #4f5d73;
}
.confirm-grid .value {
 color: #212529;
 line-height: 1.5;
 white-space: pre-wrap;
}

/* CC pills ใน modal */
.cc-pill {
 display: inline-flex;
 background: #e8f4ff;
 color: #0072e5;
 padding: 3px 10px;
 border-radius: 999px;
 font-size: 12px;
 margin-right: 6px;
 margin-bottom: 4px;
}

/* Error ใน modal */
.error-text {
 color: #e55353;
 margin-top: 12px;
}
/* base */
.status-chip {
 display: inline-flex;
 align-items: center;
 justify-content: center;
 padding: 4px 12px;
 border-radius: 999px;
 font-size: 14px;
 width: 100%;
 max-width: 140px;
 margin: 0 auto;
}

/* PENDING */
.status-chip-pending {
 background: #fff3cd;
 color: #946c00;
}

/* PROCESSING */
.status-chip-processing {
 background: #d1ecf1;
 color: #0c5460;
}

/* COMPLETED -> download button */
.status-chip-download {
 background: #2eb85c;
 color: white;
 cursor: pointer;
 border: none !important; /* 🔥 ลบเส้นขอบดำ */
 outline: none !important; /* กันตอน click แล้วมี outline */
}
.status-chip-download:hover {
 filter: brightness(0.9);
}

/* EXPIRED */
.status-chip-expired {
 background: #6c757d;
 color: white;
}

/* FAILED */
.status-chip-failed {
 background: #e55353;
 color: white;
}

/* CANCELED */
.status-chip-canceled {
 background: #adb5bd;
 color: #212529;
}

/* UNKNOWN */
.status-chip-unknown {
 background: #ced4da;
 color: #495057;
}
.usage-steps {
 background: #f8f9fa;
 border-radius: 8px;
 border: 1px solid #e9ecef;
 padding: 12px 16px;
}

.usage-title {
 font-weight: 600;
 color: #4f5d73;
 margin-bottom: 6px;
 font-size: 14px;
}

.usage-list {
 padding-left: 20px;
 margin-bottom: 0;
 font-size: 13px;
 color: #495057;
}
/* แถวฟิลเตอร์ประวัติรายงาน */
.filter-row .small {
 font-size: 0.8rem;
 font-weight: 500;
 color: #6c757d;
}

/* ให้ select / date input / ปุ่ม สูงเท่ากัน */
.filter-control {
 height: 40px;
 font-size: 14px;
}

/* ช่องวันที่ใน input-group */
.filter-date-input {
 height: 40px;
 line-height: 40px;
 box-shadow: none !important;
 cursor: pointer;
}

/* กล่อง icon ปฏิทิน */
.filter-date-icon {
 height: 40px;
 border-left: 0;
 background: #fff;
 color: #adb5bd;
 display: flex;
 align-items: center;
 justify-content: center;
}

/* ปุ่มล้างตัวกรองให้ตัวหนังสืออยู่กลางพอดี */
.filter-btn {
 display: flex;
 align-items: center;
 justify-content: center;
 padding-top: 0;
 padding-bottom: 0;
}

/* ให้ date-range filter กว้างเต็ม col-md-4 */
.filter-date-wrapper,
.filter-date-wrapper .input-group {
 width: 100%;
}
/* --------------------------------------------
   Soft Alert Styling (for Submit Alert)
   -------------------------------------------- */
/* --------------------------------------------
   Ultra Soft Transparent Alert Background
   -------------------------------------------- */
/* Base class ใส่เพิ่มให้ CAlert ใช้งาน */
.submit-alert {
 padding: 14px 18px;
 border-radius: 12px;
 border-width: 1px !important;
 backdrop-filter: blur(4px);
 -webkit-backdrop-filter: blur(4px);
}

/* ERROR — ultra soft red */
.submit-alert.c-alert-danger {
 background: rgba(229, 83, 83, 0.05) !important; /* 5% red */
 border-color: rgba(229, 83, 83, 0.25) !important; /* soft border */
 color: #b14848 !important;
}

/* SUCCESS — soft green */
.submit-alert.c-alert-success {
 background: rgba(46, 184, 92, 0.05) !important;
 border-color: rgba(46, 184, 92, 0.25) !important;
 color: #2e8b57 !important;
}

/* WARNING — soft yellow */
.submit-alert.c-alert-warning {
 background: rgba(249, 177, 21, 0.06) !important;
 border-color: rgba(249, 177, 21, 0.25) !important;
 color: #a67a12 !important;
}

/* INFO — soft blue */
.submit-alert.c-alert-info {
 background: rgba(51, 153, 255, 0.06) !important;
 border-color: rgba(51, 153, 255, 0.25) !important;
 color: #2b6cb0 !important;
}

/* --------------------------------------------
   Header
   -------------------------------------------- */
.submit-alert__header {
 display: flex;
 align-items: flex-start;
 gap: 10px;
 margin-bottom: 8px;
}

.submit-alert__icon-wrapper i {
 font-size: 18px;
}

/* icon colors */
.submit-alert__icon--success {
 color: #2eb85c;
}
.submit-alert__icon--warning {
 color: #f9b115;
}
.submit-alert__icon--danger {
 color: #e55353;
}
.submit-alert__icon--info {
 color: #3399ff;
}

/* --------------------------------------------
   Title + Subtitle
   -------------------------------------------- */
.submit-alert__title {
 font-size: 14px;
 font-weight: 600;
 color: #2c3e50;
}

.submit-alert__subtitle {
 font-size: 12px;
 color: #6c757d;
}

/* --------------------------------------------
   Item List
   -------------------------------------------- */
.submit-alert__list {
 list-style: none;
 padding: 6px 0 0;
 margin: 0;
 border-top: 1px dashed rgba(0, 0, 0, 0.08);
}

.submit-alert__item {
 padding: 8px 0;
 border-bottom: 1px dashed rgba(0, 0, 0, 0.05);
}

.submit-alert__item:last-child {
 border-bottom: none;
}

.submit-alert__item-main {
 display: flex;
 align-items: center;
 justify-content: space-between;
}

/* รายชื่อรายงาน */
.submit-alert__label {
 font-size: 13px;
 color: #2b2b2b;
}

/* status badge – soft look */
.submit-alert__status {
 font-size: 11px;
 padding: 3px 10px;
 border-radius: 999px;
 font-weight: 500;
}

/* สีแบบ soft ไม่แย่งสายตา */
.submit-alert__status--pending {
 background: #fff8dd;
 color: #a37600;
}

.submit-alert__status--processing {
 background: #e8f6fa;
 color: #0b657a;
}

.submit-alert__status--completed {
 background: #e8fbee;
 color: #1f7a34;
}

.submit-alert__status--expired {
 background: #f0f0f0;
 color: #555;
}

.submit-alert__status--failed {
 background: #ffecec;
 color: #b02929;
}

.submit-alert__status--canceled,
.submit-alert__status--skipped {
 background: #f1f3f5;
 color: #616b74;
}

/* reason text */
.submit-alert__reason {
 font-size: 11px;
 color: #6c757d;
 margin-top: 3px;
}

.btn-ellipsis {
 width: 32px;
 height: 32px;
 padding: 0;
 border-radius: 8px;
 display: inline-flex;
 align-items: center;
 justify-content: center;
}

.btn-ellipsis i {
 font-size: 16px;
 color: #6c757d;
}

.btn-ellipsis:hover {
 background-color: #f1f3f5;
}
/* กล่องเงื่อนไขการใช้งาน */
.usage-steps {
  background: linear-gradient(180deg, #f8f9fa, #ffffff);
  border: 1px solid #e9ecef;
  border-radius: 5px;
  padding: 14px 18px;
}

/* header */
.usage-header {
  display: flex;
  align-items: center;
  margin-bottom: 2px;
  color: #4f5d73;
}

.usage-header i {
  font-size: 16px;
  color: #3399ff;
}

/* title */
.usage-title {
  font-weight: 600;
  font-size: 14px;
}

/* list */
.usage-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

/* item */
.usage-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 12px;
  color: #495057;
  line-height: 1.6;
  margin-bottom: 2px;
}

/* bullet */
.usage-bullet {
  color: #3399ff;
  font-weight: bold;
  line-height: 1.6;
}

/* text */
.usage-text {
  flex: 1;
}

/* item hover (เบามาก) */
.usage-item:hover {
  color: #212529;
}

</style>
